/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Rank_NationalInputs */



/**
* | output |
* | --- |
* | "National" |
*
* @param {Promo_Rank_NationalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_rank_national = /** @type {((inputs?: Promo_Rank_NationalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Rank_NationalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("National")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nacional")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nacional")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nazionale")
	return /** @type {LocalizedString} */ ("National")
});